<template>
  <section class="scene">
    <div class="container">
      <a-typography-title :level="1" style="margin-bottom:20px">
        方案价值
      </a-typography-title>
      <a-typography-paragraph>
        <div>
          {{
          '随着企业数字化业务的不断膨胀，云成本迅速增长，亟需对云上成本进行优化管理。'
          +'麦肯锡的一份调查则显示：与单纯利用公有云的方案相比，混合云可以帮助客户提高2.5倍的业务价值，这进一步加强了企业迈向混合云部署的期待。'
        }}
        </div>
        <div style="margin-top:10px">
          {{
          '星汉未来应市场需求，推出运维托管解决方案。'
          +'通过提供“混合云托管”、“Serverless托管”等两种模式，全面帮助企业大幅降低IT成本。'
        }}
        </div>
      </a-typography-paragraph>
    </div>
    <div class="solution">
      <div class="solution_title">
        <div class="solution_title-line_left" v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)"></div>
        <a-typography-title :level="1">
          星汉未来运维托管解决方案
        </a-typography-title>
        <div class="solution_title-line_right" v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)"></div>
      </div>
      <div class="solution_content">
        <a-row :gutter="[60,30]">
          <a-col v-for="(item,index) in expand.list" :key="index" :xs="24" :md="12" :xl="12">
            <div class="item">
              <div class="image"> {{ item.title }}</div>
              <a-typography-text>
                <div class="item_discount">
                  <div class="item_discount-div">
                    {{ item.text }}
                  </div>
                  <div class="item_discount-div">
                    <div>
                      {{item.discount}}
                    </div>
                    <div>
                      折
                    </div>
                  </div>
                </div>
              </a-typography-text>
              <a-typography-paragraph>
                <p class="item_list" v-for="v in item.list" :key="v">
                  {{ v }}
                </p>
              </a-typography-paragraph>
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="solution_server">
        <a-row :gutter="[150,30]">
          <a-col v-for="(item,index) in expand.list2" :key="index" :xs="24" :md="12" :xl="12">
            <div :class="'solution_server-item_'+index">
              <div class="solution_server-item_title">
                {{item.title}}
              </div>
              <a-typography-paragraph v-if="index===0">
                {{item.text}}
              </a-typography-paragraph>
              <a-typography-paragraph v-else>
                <div class="item_list" v-for="v in item.list" :key="v">
                  {{ v }}
                </div>
              </a-typography-paragraph>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from "@interface/public";

export default {
  name: "trusteeship_value",
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: "混合云托管方案",
            text: "算力成本降至当前的",
            discount: "8",
            list: [
              "迁移至星汉未来混合云平台，结合公有云丰富的产品线和私有云低廉的服务器成本；",
              "无论您月度云消耗是一万，十万，还是一百万，都可让算力成本降至当前的8折。",
            ],
          },
          {
            title: "Serverless托管方案",
            text: "算力成本降至当前的",
            discount: "7",
            list: [
              "迁移至星汉未来Serverless平台，实现分钟级应用部署、无人化运维保障、自动化成本治理；",
              "一站式管理企业内各类开源、自研、商业化应用，打造智能高效的企业云操作系统，可让算力成本降至当前的7折。",
            ],
          },
        ],
        list2: [
          {
            title: "服务范围",
            text: "星汉未来提供综合算力服务，提供独立的VPC，以及虚拟机、容器的算力，服务周期默认为一年，预付费模式，以公有云一年期算力折扣价为价格基准。",
          },
          {
            title: "服务客户",
            list: [
              "采用公有云或者混合云架构的客户；",
              "需要大幅降低IT成本的客户。",
            ],
          },
        ],
      },
    };
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "@resource/css/_global.less";

@image: "@{src_image}page/planTrusteeship/";

.scene {
  overflow: hidden;
  position: relative;
  z-index: 0;
  .bg("@{image}value.jpg");
  background-size: cover;
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 15px 0;
    margin: 0 auto;
    .borderBox();
  }
  .solution {
    position: relative;
    max-width: @grid_xl;
    padding: @space_mo 15px;
    margin: 0 auto;
    .borderBox();
    &_title {
      display: flex;
      justify-content: center;
      align-items: center;
      .ant-typography {
        margin: 0 @margin_mo;
      }
      &-line {
        .line_bg(@direction:left) {
          width: 340px;
          height: 1px;
          background: linear-gradient(
            to @direction,
            rgba(63, 92, 236, 1),
            rgba(134, 154, 255, 0)
          );
        }
        &_left {
          .line_bg(left);
        }
        &_right {
          .line_bg(right);
        }
      }
    }
    &_content {
      text-align: center;
      margin: 80px auto @margin_mo;
      .item {
        position: relative;
        background: @color_white;
        border-radius: 8px;
        text-align: center;
        .shadow(0 0 15px fade(@color_black, 10));
        padding: 50px 50px 0;
        min-height: 380px;
        .image {
          @width: 320px;
          @top: 38px;
          @h: 100px;
          text-align: center;
          left: 50%;
          transform: translateX(calc(-@width / 2));
          height: @h;
          width: @width;
          position: absolute;
          top: -@top;
          .bg("@{image}content_bg.png",100% , auto);
          .font(center, @title, @color_2, @title_mo);
          line-height: @h;
        }
        .flex_center() {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &_discount {
          .flex_center();
          width: 100%;
          height: 60px;
          margin: 25px auto;
          border-radius: 120px;
          background: linear-gradient(
            to right,
            rgba(253, 215, 105, 0.2),
            rgba(246, 158, 45, 0.1)
          );
          &-div {
            &:nth-child(1) {
              .font(center, @title_sub_mo, @color_1, @title_sub_mo);
            }
            &:nth-child(2) {
              .flex_center();
              div {
                &:nth-child(1) {
                  margin-left: 6px;
                  .font(center, @font_1, @color_yellow, @font_1);
                }
                &:nth-child(2) {
                  position: relative;
                  bottom: -2px;
                  margin-left: 5px;
                  .font(center, @text, @color_yellow, @text);
                }
              }
            }
          }
        }
        &_list {
          position: relative;
          &::before {
            content: "";
            display: block;
            position: absolute;
            top: 10px;
            left: -10px;
            right: auto;
            bottom: auto;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: #6a6f7f;
          }
        }
      }
    }
    
    &_server {
      position: relative;
      background: @color_white;
      border-radius: 8px;
      text-align: center;
      .shadow(0 0 15px fade(@color_black, 10));
      padding: 10px 60px;
      .title_icon(@img:"") {
        padding-left: 42px;
        .font(left, @title, @color_black, @title_mo);
        position: relative;
        &::before {
          content: "";
          display: block;
          position: absolute;
          top: 3px;
          left: -5px;
          right: auto;
          bottom: auto;
          border-radius: 50%;
          .bg("@{image}@{img}",26px, 26px);
          width: 30px;
          height: 30px;
        }
      }
      &-item_0 {
        .solution_server-item_title {
          .title_icon("server_icon.png");
        }
      }
      &-item_1 {
        .solution_server-item_title {
          .title_icon("user_icon.png");
        }
        .item_list {
          position: relative;
          padding-left: 10px;
          &::before {
            content: "";
            display: block;
            position: absolute;
            top: 10px;
            left: 0px;
            right: auto;
            bottom: auto;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: #6a6f7f;
          }
        }
      }
    }
  }
}

.ant-row {
  margin: @margin auto;
}
h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}
div.ant-typography {
  margin: @margin_mo 0;
  .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
}
@media screen and (max-width: -1px+@grid_md) {
  .scene {
    .container {
      padding: @space_mo 15px;
    }
    .solution {
      padding: @space_mo 15px;
      &_content {
        .item {
          min-height: 0px;
          padding-bottom: 40px;
        }
      }
    }
  }

  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
}
</style>